import React, { useState, useEffect } from "react";
import {
  Box,
  Button,
  Alert,
  Snackbar,
  CircularProgress,
  Switch,
  FormControlLabel,
} from "@mui/material";
// Иконка заменена на текстовый символ для совместимости

// Components
import PageWrap from "src/components/PageWrap";
import SiteSettings from "src/components/AutoChange/SiteSettings";
import CurrencyMapping from "src/components/AutoChange/CurrencyMapping";
import SystemSettings from "src/service/SystemSettings";

const AutoChangeSettings = () => {
  const [settingsData, setSettingsData] = useState({
    changerCurrencis: [],
    exchangerCurrencies: [],
  });
  const [settings, setSettings] = useState({
    enabledForSites: [],
    linkedCurrency: [],
    enabled: false,
  });
  const [loading, setLoading] = useState(false);
  const [saving, setSaving] = useState(false);
  const [snackbar, setSnackbar] = useState({
    open: false,
    message: "",
    severity: "success",
  });

  useEffect(() => {
    loadSettings();
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  const loadSettings = async () => {
    try {
      setLoading(true);

      // Загружаем настройки автообмена
      const response = await SystemSettings.getAutoChangeSettings();
      const data = response.data;

      setSettings({
        enabledForSites: data.enabledForSites || [],
        linkedCurrency: data.linkedCurrency || [],
        enabled: data.enabled || false,
      });

      const responseSettingsData =
        await SystemSettings.autoChangeSettingsGetData();
      const settingsData = responseSettingsData.data;

      setSettingsData({
        changerCurrencis: settingsData.changerCurrencis || [],
        exchangerCurrencies: settingsData.exchangerCurrencies || [],
      });
    } catch (err) {
      console.error("Ошибка загрузки настроек автообмена:", err);
      showSnackbar("Ошибка загрузки настроек", "error");
    } finally {
      setLoading(false);
    }
  };

  console.log({ settingsData });

  const handleDataChange = (newData) => {
    setSettings((prev) => ({ ...prev, ...newData }));
  };

  const handleSwitchChange = (event) => {
    const newValue = event.target.checked;
    setSettings((prev) => ({ ...prev, enabled: newValue }));
  };

  const handleSave = async () => {
    try {
      setSaving(true);
      await SystemSettings.updateAutoChangeSettings(settings);
      showSnackbar("Настройки успешно сохранены", "success");
    } catch (err) {
      console.error("Ошибка сохранения настроек:", err);
      showSnackbar("Ошибка сохранения настроек", err?.response?.data?.message);
    } finally {
      setSaving(false);
    }
  };

  const showSnackbar = (message, severity) => {
    setSnackbar({ open: true, message, severity });
  };

  const handleCloseSnackbar = () => {
    setSnackbar((prev) => ({ ...prev, open: false }));
  };

  if (loading) {
    return (
      <PageWrap title="Авто Обмен">
        <Box
          display="flex"
          justifyContent="center"
          alignItems="center"
          minHeight="400px"
        >
          <CircularProgress />
        </Box>
      </PageWrap>
    );
  }

  return (
    <PageWrap title="Авто Обмен">
      <Box sx={{ display: "flex", flexDirection: "column", gap: 3 }}>
        {/* Переключатель крипто авто обмена */}
        <Box sx={{ mb: 2 }}>
          <FormControlLabel
            control={
              <Switch
                checked={settings.enabled || false}
                onChange={handleSwitchChange}
                color="primary"
              />
            }
            label="Крипто авто обмен"
          />
        </Box>

        {/* Настройки по сайтам */}
        <SiteSettings onDataChange={handleDataChange} />

        {/* Сопоставление кодов валют */}
        <CurrencyMapping
          onDataChange={handleDataChange}
          exchangerCurrencies={settingsData.exchangerCurrencies}
          changerCurrencis={settingsData.changerCurrencis}
        />

        {/* Кнопка сохранения */}
        <Box sx={{ display: "flex", justifyContent: "flex-end", mt: 2 }}>
          <Button
            variant="contained"
            onClick={handleSave}
            disabled={saving}
            size="large"
          >
            {saving ? "Сохранение..." : "💾 Сохранить настройки"}
          </Button>
        </Box>
      </Box>

      {/* Уведомления */}
      <Snackbar
        open={snackbar.open}
        autoHideDuration={6000}
        onClose={handleCloseSnackbar}
        anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
      >
        <Alert
          onClose={handleCloseSnackbar}
          severity={snackbar.severity}
          sx={{ width: "100%" }}
        >
          {snackbar.message}
        </Alert>
      </Snackbar>
    </PageWrap>
  );
};

export default AutoChangeSettings;
